import moment from 'moment';
export const HOLIDAY_DATE_FORMAT = 'YYYY-MM-DD';
const holidays = {
  '2019-11-28': {
    momentDate: moment('2019-11-28', HOLIDAY_DATE_FORMAT),
    title: 'Thanksgiving'
  },
  '2019-12-24': {
    momentDate: moment('2019-12-24', HOLIDAY_DATE_FORMAT),
    title: 'Christmas Eve'
  },
  '2019-12-25': {
    momentDate: moment('2019-12-25', HOLIDAY_DATE_FORMAT),
    title: 'Christmas Day'
  },
  '2020-01-01': {
    momentDate: moment('2020-01-01', HOLIDAY_DATE_FORMAT),
    title: 'New Year’s Day'
  },
  '2020-02-17': {
    momentDate: moment('2020-02-17', HOLIDAY_DATE_FORMAT),
    title: 'President’s Day'
  },
  '2020-05-25': {
    momentDate: moment('2020-05-25', HOLIDAY_DATE_FORMAT),
    title: 'Memorial Day'
  },
  '2020-07-03': {
    momentDate: moment('2020-07-03', HOLIDAY_DATE_FORMAT),
    title: 'Independence Day'
  },
  '2020-09-07': {
    momentDate: moment('2020-09-07', HOLIDAY_DATE_FORMAT),
    title: 'Labor Day'
  },
  '2020-11-26': {
    momentDate: moment('2020-11-26', HOLIDAY_DATE_FORMAT),
    title: 'Thanksgiving Day'
  },
  '2020-12-25': {
    momentDate: moment('2020-12-25', HOLIDAY_DATE_FORMAT),
    title: 'Christmas Day'
  },
  '2021-01-01': {
    momentDate: moment('2021-01-01', HOLIDAY_DATE_FORMAT),
    title: 'New Year’s Day'
  },
  '2021-05-31': {
    momentDate: moment('2021-05-31', HOLIDAY_DATE_FORMAT),
    title: 'Memorial Day'
  },
  '2021-07-05': {
    momentDate: moment('2021-07-05', HOLIDAY_DATE_FORMAT),
    title: 'Independence Day'
  },
  '2021-09-06': {
    momentDate: moment('2021-09-06', HOLIDAY_DATE_FORMAT),
    title: 'Labor Day'
  },
  '2021-11-25': {
    momentDate: moment('2021-11-25', HOLIDAY_DATE_FORMAT),
    title: 'Thanksgiving Day'
  },
  '2021-12-25': {
    momentDate: moment('2021-12-25', HOLIDAY_DATE_FORMAT),
    title: 'Christmas Day'
  }
};

export default holidays;
